import ApiService from '@/services/api';
import { EntityBuilder } from '@decahedron/entity';
import Part from '@/entities/Part';

let instance: PartService = null;

export default class PartService {
  apiService: ApiService = null;

  partsList: Part[] = null;

  part: Part = null;

  constructor() {
    if (!instance) {
      this.apiService = new ApiService();
      instance = this;
    }

    return instance;
  }

  get list(): Part[] {
    if (!this.partsList) {
      this.setList();
    }

    return this.partsList;
  }

  setPartList(parts: Part[]) {
    let position = 1;
    this.partsList = parts.sort((a: Part, b: Part) => a.position - b.position).map((part: Part) => {
      const partCopy = part;
      partCopy.position = position;
      position += 1;

      return partCopy;
    });
  }

  protected setList() {
    this.partsList = [];
    this.getList().then((parts: Part[]) => {
      this.setPartList(parts);
    });
  }

  protected getList() {
    return this.apiService.get('parts')
      .then((response) => EntityBuilder.buildMany<Part>(Part, response.data));
  }

  get(id: string): Promise<Part> {
    this.part = this.list.find((part) => part.id === id);

    return this.apiService.get(`parts/${id}`)
      .then((response) => EntityBuilder.buildOne(Part, response.data));
  }

  move(from: number, to: number) {
    for (let i = 0; i < this.list.length; i += 1) {
      if (i === from) {
        this.list[i].position = to + 1;
      } else if (from < to && i > from && i <= to) {
        this.list[i].position -= 1;
      }
      if (from > to && i < from && i >= to) {
        this.list[i].position += 1;
      }
    }

    this.setPartList(this.list);
  }

  saveOrder(parts: Part[]) {
    return this.apiService.put('parts/position', parts.map((part: Part) => {
      const partCopy = part;
      return {
        id: partCopy.id,
        position: partCopy.position,
      };
    }));
  }

  save(part: Part) {
    if (part.id) {
      return this.apiService.put(`parts/${part.id}`, part.toJson())
        .then((response) => {
          this.setList();
          return EntityBuilder.buildOne<Part>(Part, response.data);
        });
    }

    return this.apiService.post('parts', part.toJson())
      .then((response) => {
        this.setList();
        return EntityBuilder.buildOne<Part>(Part, response.data);
      });
  }

  delete(part: Part) {
    return this.apiService.put(`parts/${part.id}/archive`)
      .then((response) => {
        if (this.partsList?.length) {
          for (let n = 0; n < this.partsList.length; n += 1) {
            if (this.partsList[n].id === part.id) {
              this.partsList.splice(n, 1);
              break;
            }
          }
        }

        return response;
      });
  }
}
